import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {Popover} from "@mantine/core";
import React from "react";
import {sideMenuButtonsProps} from "../../types/types";



export function SideMenuButtons(props: sideMenuButtonsProps) {
    const [openedDescription, setOpenedDescription] = React.useState(false);

    return (
        <Popover
            opened={openedDescription}
            onClose={() => setOpenedDescription(false)}
            onMouseEnter={() => setOpenedDescription(true)}
            onMouseLeave={() => setOpenedDescription(false)}
            position="right"
            placement="center"
            withArrow
            trapFocus={false}
            closeOnEscape={false}
            transition="pop-top-left"
            width={260}
            styles={{body: {pointerEvents: 'none'}}}
            target={
                <a href={props.href} className={props.hrefClassName + (props.isActive ? " active" : "")}>
                    <FontAwesomeIcon icon={props.icon} size={"2x"}/>
                </a>
            }
        >
            <div style={{display: 'flex'}}>
                {props.buttonName}
            </div>
        </Popover>

    )
}
